var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var ArrowDownRight = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6,6 L6,13 L17.293,13 L14.1464466,9.85355339 C13.9728803,9.67998704 13.9535951,9.41056264 14.0885912,9.2156945 L14.1464466,9.14644661 C14.320013,8.97288026 14.5894374,8.95359511 14.7843055,9.08859116 L14.8535534,9.14644661 L18.8535534,13.1464466 C19.0488155,13.3417088 19.0488155,13.6582912 18.8535534,13.8535534 L14.8535534,17.8535534 C14.6582912,18.0488155 14.3417088,18.0488155 14.1464466,17.8535534 C13.9728803,17.679987 13.9535951,17.4105626 14.0885912,17.2156945 L14.1464466,17.1464466 L17.293,14 L5,14 L5,6 L6,6 Z" })));
};
ArrowDownRight.displayName = 'ArrowDownRight';
export default ArrowDownRight;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowDownRight.js.map